import { authToken } from '@wellesley/auth'
import {
  useLazyGetApiV1AppsUserQuery,
  useLazyGetApiV1AppsQuery,
} from '@wellesley/apps'
import { Application } from '@wellesley/openapi'
import { useCallback } from 'react'

export const useAppsListQuery = () => {
  const [getAppsUser] = useLazyGetApiV1AppsUserQuery()
  const [getGuestApps] = useLazyGetApiV1AppsQuery()

  const getApps = useCallback(
    async (): Promise<Application[]> =>
      authToken.hasToken() ? getAppsUser().unwrap() : getGuestApps().unwrap(),
    [getAppsUser, getGuestApps],
  )

  return getApps
}
